export default {
    state: {
        isLoading: false,
    },
    getters: {
        getIsLoading(state) {
            return state.isLoading;
        },
    },
    mutations: {
        setLoadingState(state, payload) {
            state.isLoading = payload;
        },
    },
};
